__turbopack_context__.v({
  "className": "S2sK2W_className",
  "variable": "S2sK2W_variable",
});
